import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './css/Item.scss'
import Select from '../../../../../ui/Select'

@injectIntl
export default class Item extends Component {
    static propTypes = {
        handleUpdateOrder: PropTypes.func,
        intl: intlShape.isRequired,
        isEditable: PropTypes.bool,
        isSingle: PropTypes.bool,
        order: PropTypes.any,
        position: PropTypes.any,
        service: PropTypes.any,
    }

    handleCountSelect = (event) => {
        const { order, service, position } = this.props;

        const value = parseInt(event.target.value, 10) || null;
        let newOrder = order;

        if (value) {
            newOrder = newOrder.setIn(
                ['positions', service.get('id'), position.get('id')],
                parseInt(event.target.value, 10) || null);
        } else {
            newOrder = newOrder.removeIn(['positions', service.get('id'), position.get('id')]);
        }

        this.props.handleUpdateOrder(newOrder);
    }

    generateOptions(min, max, bundleVolume, service) {
        const values = [];
        let bundleVol = parseInt(bundleVolume, 10) || 1;
        if (service === 'service.pickup') bundleVol = 1;
        values.push(0);
        for (let i = parseInt(min, 10); i <= parseInt(max, 10); i++) {
            if (i % bundleVol !== 0) continue;
            values.push(i);
        }
        return values;
    }

    // TODO: We should create a TranslationUtil or somthing like that
    translate = (messageId) => {
        if (!this.props.intl.messages[messageId]) {
            return null;
        }
        return <FormattedMessage id={messageId} />;
    }

    // TODO: We could create a Component for a deposit badge if we need it somwhere else
    renderDeposit = () => {
        const { position, service } = this.props;

        if (!position.get('deposit') || service.get('alias') !== 'service.delivery') return null;

        return (
            <div className={styles.deposit}>
                <div className={styles.depositContent}>
                    <span className={styles.depositValue}>{position.get('deposit')},- €</span>
                    <span className={styles.depositLabel}>
                        <FormattedMessage id={'frontend.form_position.label.deposit'} />
                    </span>
                </div>
            </div>
        );
    }

    render() {
        const { order, service, position, isEditable, isSingle } = this.props;

        const minValue = position.get('minQuantity');
        const maxValue = position.get('maxQuantity');
        const isRestricted = position.get('isRestricted') || false;

        const count = order.getIn(['positions', service.get('id'), position.get('id')]);
        const image = `/img/products/${service.get('alias').split('.').pop()}_${position.get('alias').split('.').pop()}.svg`;
        const options = this.generateOptions(
            minValue, maxValue, position.get('bundleVolume'), service.get('alias')
        );

        return (
            <div className={classNames(
                styles.container,
                !isSingle ? styles.multiContainer : null
            )}>
                <div className={styles.item}>
                    <img className={styles.image} role='presentation' src={image} />
                    <div className={styles.select}>
                        {
                            isEditable
                                ? (
                                    <Select
                                        value={count || 0}
                                        onChange={this.handleCountSelect}
                                        disabled={isRestricted}
                                    >
                                        {
                                            options.map((value, index) => (
                                                <option key={index} value={value}>{value}</option>
                                            ))
                                        }
                                    </Select>
                                )
                                : (
                                    <div className={styles.amount}>
                                        <span>x{count ? count : 0}</span>
                                    </div>
                                )
                        }
                    </div>
                    {this.renderDeposit()}
                </div>
                <p className={styles.hint}>
                    {this.translate(`frontend.form_position.hint.product.${service.get('mode')}.${service.get('alias')}.${position.get('alias').split('.').pop()}`)}
                </p>
            </div>
        );
    }
}
